import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import styles from './style.module.scss';
import classNames from 'classnames';
import Heading from 'shared/components/common/heading/Heading';
import CustomInput from 'shared/components/common/custom_input/CustomInput';
import CustomButton from 'shared/components/common/custom_button/CustomButton';
import { useSelector } from 'react-redux';
import CustomSelect from 'shared/components/common/custom_selection/CustomSelection';
import DashboardWrapper from 'shared/components/common/dashboard_wrapper/DashboardWrapper';
import { GetAllCategoryQuery } from 'shared/services/category_service/CategoryService';
import { GetAllSubCategoryQuery } from 'shared/services/sub_category_service/SubCategoryService';
import { GetAllProductQuery } from 'shared/services/product_service/ProductService';
import { GetAllBrandQuery } from 'shared/services/brand_service/BrandService';
import { useFormik } from 'formik';
import OverlayLoading from 'shared/screen_loader/overlay_loader/OverlayLoading';
import { PoVS } from 'shared/utils/validation/AuthValidation';
import { AddPOMutation } from 'shared/services/po_service/POService';
import { useNavigate } from 'react-router-dom';
import { routeConstant } from 'shared/routes/RouteConstant';
import Select from 'react-select';
import InnerInvenTable from './InnerInvenTable';
import { GetNonInventoryPOQuery } from 'shared/services/po_service/POService';
import { AddInventoryMutation } from 'shared/services/inventory_service/InventoryService';
import moment from 'moment';
import { isRestrictActions } from 'shared/utils/Helper';
import { screenActionEnum, screenEnum } from 'shared/utils/Enum';
import { useLocation } from 'react-router-dom';
import UpdateInvenotyMod from 'shared/modal/update_inventory/UpdateInvenotyMod';
import { wareHouse } from 'shared/utils/Enum';
import WareHouseAdd from 'shared/modal/add_warehouse/WareHouse';
import { GetAllWarehouse } from 'shared/services/ware_house_service/WareHouseService';


export default function UpdateInventory({ show, handleClose, isEdit = false }) {
    const {
        theme: { theme }
    } = useSelector((state) => state.root);
    const { data: PoList, isLoading: POLoading, isError, error } = GetNonInventoryPOQuery();
    const { mutate: addInventory, isLoading: InventoryLoading, isSuccess: ProductIsSuccess } = AddInventoryMutation();
    const location = useLocation();
    const navigate = useNavigate();
    let backvalue = location?.state?.data?.po;

    const [PoListing, setPoListing] = useState([]);
    const [SelectedPo, setSelectedPo] = useState(backvalue ? backvalue : null);

    const [PoOptions, setPoOptions] = useState([]);
    const [changeqty, setchangeqty] = useState([]);
    const [showWareModal, setshowWareModal] = useState(false);
    const [wareHouses, setWareHouses] = useState([]); // Fixed: initialize as array
    const [wareHousesValue, setwareHousesValue] = useState(null); // Fixed: initialize as null
    const { data: listWareHouse } = GetAllWarehouse();






    const updateHandler = (payload) => {
        setchangeqty()
        setPoListing(prevList =>
            prevList.map(item =>
                item._id === payload.inventory
                    ? { ...item, quantity: payload.quantity, poqty: payload.poqty, Remaining: payload.Remaining || 0 }
                    : item
            )
        );
    };
    const closeProductHandler = () => {

        setshowWareModal(false);
    }

    const createInventry = () => {
        let obj = {
            purchaseOrder: SelectedPo?._id,
            products: [],

        };
        PoListing.map((item) => {

            obj.products.push({
                sku: item?.sku,
                quantity: item?.Received_QTY ? item?.Received_QTY : item?.quantity,
                remaining: item?.Remaining || 0,
                closed: (item?.Remaining || 0) === 0 ? "true" : "false",// string value
                poqty: item?.poqty ? item.poqty : item?.quantity,
            });
        });
        addInventory(obj);
    };

    useEffect(() => {
        if (PoList && wareHousesValue?.value) {
            const selectedWhId = String(wareHousesValue.value);

            // Filter POs by warehouse only. The API already returns non-inventory POs.
            const finalPOs = PoList.filter(po => {
                const whId = po?.whareHouse?.warehouse?._id || po?.whareHouse?.warehouse;
                return String(whId) === selectedWhId;
            });

            setPoOptions(finalPOs.map(p => ({
                ...p,
                label: p.order_number,
                value: p._id
            })));
        } else {
            setPoOptions([]);
        }
    }, [PoList, wareHousesValue]);


    useEffect(() => {
        if (listWareHouse) {
            const options = listWareHouse.map(w => ({
                ...w,
                label: w?.code,
                value: w?._id,
            }));
            setWareHouses(options);  // Update the state with new options
        }
    }, [listWareHouse]);


    useEffect(() => {

        if (ProductIsSuccess) {
            navigate(routeConstant.admin.inventory.list.path);
        }
    }, [ProductIsSuccess]);
    console.log(PoList, "PoListcddf");

    return (
        <DashboardWrapper>
            <div className={classNames(styles.UserContainer, 'text-start')}>
                <div>
                    <div className={styles.Header}>
                        <Heading heading={'Add Inventory'} headingStyle={styles.Heading} />
                    </div>
                    <div className={classNames(`${theme}ModalBackground`, styles.Body)}>
                        <div className={classNames(styles.TableFlex)}>
                            <div className={classNames(styles.InnerTableFlex)}>
                                <div>
                                    <label className="LightFontColor Label style_InputLabel__lhse5">Warehouse</label>
                                    <Select
                                        options={wareHouses}
                                        isSearchable
                                        isClearable
                                        value={wareHousesValue}
                                        placeholder="Select Warehouse"
                                        menuPortalTarget={document.body}
                                        styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                        onChange={async (item) => {
                                            if (item?.value === "__add_new__") {
                                                setshowWareModal(true);
                                                return;
                                            }
                                            setwareHousesValue(item)
                                        }}
                                    />
                                </div>
                                <div>
                                    <label className="LightFontColor Label style_InputLabel__lhse5">Purchase Order</label>
                                    <Select
                                        options={PoOptions}
                                        isSearchable
                                        isClearable
                                        value={SelectedPo}
                                        placeholder="Select Purchase Order"
                                        menuPortalTarget={document.body}
                                        styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                        onChange={(item) => {
                                            if (item) {
                                                // SKU matching removed as requested. Showing all items for the selected PO.
                                                setPoListing(item.order || []);
                                                setSelectedPo(item);
                                            } else {
                                                setPoListing([]);
                                                setSelectedPo(null);
                                            }
                                        }}
                                    />
                                </div>
                            </div>

                        </div>
                        <div className={classNames(styles.ButtonContainer, 'd-flex justify-content-start')}></div>
                    </div>
                </div>
                <InnerInvenTable PoList={PoListing} OffPage={true} SelectedPos={SelectedPo} updateHandler={updateHandler} />
                <WareHouseAdd show={showWareModal} handleClose={closeProductHandler} />

                <div className={styles.ButtonContainer}>
                    {PoListing.length > 0 && (
                        <>
                            <CustomButton text={'Cancel'} containerStyle={styles.CancelBtn} submitHandle={() => navigate(-1)} />
                            <CustomButton text={'Create Inventory'} containerStyle={styles.SubmitBtn} submitHandle={createInventry} />
                        </>
                    )}
                </div>

            </div>
            {InventoryLoading && <OverlayLoading />}
        </DashboardWrapper>
    );

}
